import { useQuery } from "react-query"

import { useConfig } from "../components/ConfigContext"
import { load } from "../lib"

const loadCategories = (filter, apiUrl) => {
  const { divisionId } = filter;
  return load(`${apiUrl}/categories`, {
    filter: {
      where: {
        divisionId,
      },
    }
  })
}

const loadCategory = (categoryId, apiUrl) => {
  return load(`${apiUrl}/categories/${categoryId}`)
}

const loadDivisions = (filter, apiUrl) => {
  return load(`${apiUrl}/divisions`, {
    filter: {
      order: 'order',
    }
  })
}

const loadDivision = (divisionId, apiUrl) => {
  return load(`${apiUrl}/divisions/${divisionId}`)
}

export const useCategories = (filter, options) => {
  const { apiUrl } = useConfig();
  return useQuery(
    ['categories', filter],
    () => loadCategories(filter, apiUrl),
    options
  )
}

export const useCategory = (categoryId, options) => {
  const { apiUrl } = useConfig();
  return useQuery(
    ['category', categoryId],
    () => loadCategory(categoryId, apiUrl),
    { enabled: !!categoryId, ...options }
  )
}

export const useDivisions = (filter, options) => {
  const { apiUrl } = useConfig();
  return useQuery(
    ['divisions', filter],
    () => loadDivisions(filter, apiUrl),
    options
  )
}

export const useDivision = (divisionId, options) => {
  const { apiUrl } = useConfig();
  return useQuery(
    ['division', divisionId],
    () => loadDivision(divisionId, apiUrl),
    { enabled: !!divisionId, ...options }
  )
}
